export type AppMode =
  | 'local'
  | 'development'
  | 'staging'
  | 'preproduction'
  | 'production';

const AppConfig = () => {
  const env = process.env.NODE_ENV;
  const mode = process.env.REACT_APP_MODE as AppMode;
  const testHost = process.env.REACT_APP_TEST_HOST;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const version = process.env.npm_package_version;
  const hoopsViewerUrl = process.env.REACT_APP_VIEWER_URL;
  const hoopsViewerAPI = process.env.REACT_APP_VIEWER_API;
  const graphqlUrl = process.env.REACT_APP_GRAPHQL_URL;
  const fileApiUrl = process.env.REACT_APP_FILE_API_URL; // new
  const partnersUrl = process.env.REACT_APP_PARTNER_BASE_URL;
  const cloudUrl = process.env.REACT_APP_CLOUD_BASE_URL;
  const wordPressUrl = process.env.REACT_APP_WORD_PRESS_BASE_URL;
  const hackleSdkKey = process.env.REACT_APP_HACKLE_SDK_KEY;
  const connectUrl = process.env.REACT_APP_CONNECT_URL;
  const capaViewerApi = process.env.REACT_APP_VIEWER_API;
  const IMPStoreCode = process.env.REACT_APP_IAMPORT_STORE_CODE;
  const IMPWebhookUrl = process.env.REACT_APP_IAMPROT_WEBHOOK_URL;
  const Mocking = process.env.REACT_APP_MOCKING;
  const TeamsPaymentWebhookURL =
    process.env.REACT_APP_TEAMS_PAYMENT_WEBHOOK_URL ?? '';

  return {
    env,
    mode,
    testHost,
    baseUrl,
    version,
    fileApiUrl,
    partnersUrl,
    graphqlUrl,
    cloudUrl,
    hoopsViewerUrl,
    hoopsViewerAPI,
    hackleSdkKey,
    connectUrl,
    wordPressUrl,
    capaViewerApi,
    IMPStoreCode,
    IMPWebhookUrl,
    Mocking,
    TeamsPaymentWebhookURL
  };
};

export default AppConfig();
